<template>
    <hts-slide-over
        :show="visible"
        color="main"
        :width-size="props.sizeSlideOver"
        :rules="form.rulesDriver"
        :submit="handleSubmitFormEditDriver"
        :undo-enable="true"
        :width="40"
        :title="$t('labels.edit')"
        @close="closeOverSide"
        @undo="undo()">
        <template #body>
            <div class="hts-vehicles-ignore-add-vehicle">
                <div class="hts-vehicles-ignore-add-vehicle__container-body">
                    <hts-card :title="$t('labels.generalInformation')">
                        <div
                            class="grid gap-4"
                            :class="columnClass">
                            <hts-form-input
                                v-model="dataFormEditDriver.fullName"
                                :label="$t('labels.fullName')"
                                :required="true"
                                :color="color"
                                name="fullName"
                                prop="fullName" />
                            <hts-form-input
                                v-model="dataFormEditDriver.idCardNumber"
                                :label="$t('labels.idCardNumber')"
                                :required="true"
                                :color="color"
                                name="idCardNumber"
                                prop="idCardNumber" />
                            <hts-select-cooperator
                                v-if="dataFormEditDriver.type === 1"
                                v-model="dataFormEditDriver.cooperator"
                                :name="dataFormEditDriver.cooperatorDetail?.name"
                                required
                                prop="company"
                                type-cooperator="PARTNER,VENDOR"
                                :label="$t('labels.company')" />
                            <hts-form-phone
                                v-model="dataFormEditDriver.phone"
                                :label="$t('labels.phone')"
                                required
                                prop="phone"
                                name="phone"
                                @updateCode="(val: any) => dataFormEditDriver.phone.code = val" />
                            <hts-form-input
                                v-model="dataFormEditDriver.email"
                                :label="$t('labels.email')"
                                :color="color"
                                :required="false"
                                name="email"
                                prop="email" />
                            <!-- componet select user -->

                            <hts-select-user
                                v-model="dataFormEditDriver.companyUserId"
                                v-model:name="dataFormEditDriver.companyUserName"
                                :label="$t('labels.userAccount')"
                                creatable
                                :data-create-default="dataFormEditDriver"
                                prop="companyUserId" />
                        </div>
                    </hts-card>
                </div>
            </div>
        </template>
    </hts-slide-over>
</template>

<script setup lang="ts">
import form from './imports/form'

const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: String,
    default: 'small'
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  }
})

const visible = ref(false)
const emits = defineEmits(['close', 'refreshTables'])
const dataFormEditDriver: { [key: string]: any | {} } = ref({ ...form.initDriver })

const open = async (id: string) => {
  const api = $url.driver.driver.get

  const data = await $api(api, { uriParams: { ID: id } })
  const resData: any = data?.data.value
  if (resData?.success) {
    dataFormEditDriver.value = resData.data
  }
  visible.value = true
}

const undo = () => {
  Object.assign(dataFormEditDriver, { ...form.initDriver })
}

const closeOverSide = () => {
  undo()
  emits('close')
  visible.value = false
}

const handleSubmitFormEditDriver = () => {
  const api = $url.driver.driver.update

  const form = {
    ...dataFormEditDriver.value
  }

  $api(api, { uriParams: { ID: dataFormEditDriver.value._id }, body: form }).then((data) => {
    const resData: any = data?.data.value
    if (resData?.success) {
      emits('refreshTables')
      process.client && $toast().success($t('labels.updateSuccess', { name: $t('labels.driver') }))
      closeOverSide()
    }
  })
}

const columnClass = computed(() => {
  if ($lodash.inRange(props.column, 1, 12)) {
    return `grid-cols-${props.column}`
  }
  return 'grid-cols-1'
})

defineExpose({ open })
</script>
